import { CLAIM_STATUSES } from '@/common/constants/claims';
import { ROLE_VALUES } from '@/pages/admin/user/components/userForm/constants';

export const checkDisabled = (claimStatus, role) => {
	if (role === ROLE_VALUES.FINANCE_ANALYST) {
		return true;
	}

	if (
		![
			CLAIM_STATUSES.CORRECT_IN_PROGRESS.value,
			CLAIM_STATUSES.NONE.value,
		].includes(claimStatus)
	) {
		return true;
	}

	return false;
};
